<template>
  <div id="app" v-cloak>
        <!-- <V-touch 
            @panmove="swipe"
            @swiperight="swipeRight"
            :swipe-options="{direction: 'horizontal'}"
            style="width:100%;height:100%"
        > -->
        <transition :name="transitionName">
          <keep-alive :include="includedComponents">
              <router-view></router-view>
          </keep-alive>
        </transition>
        <!-- </V-touch> -->
  </div>
</template>
<script>
import { 
    getUserState
} from "@js/appInteraction"
// import Vue from 'vue';
// import VueTouch from 'vue-touch';
// Vue.use(VueTouch,{name:'V-touch'});
// VueTouch.config.swipe = {
//     threshold: 100 //手指左右滑动距离
// }
export default {
  data(){
    return {
      transitionName:'',
      linksArr:[]
    }
  },
  created(){
    let links = sessionStorage.getItem('links') ? JSON.parse(sessionStorage.getItem('links')) : [];
    if(links.length > 1){
      this.linksArr = links;
      sessionStorage.setItem("pagelength",links.length);
    }
  },
  watch:{
    '$route'(to,from){
      let matched = to.matched.find(item=> item.name == to.name);
      const info = {
          path: to.path,
          name: to.name,
          meta: to.meta,
          componentName: matched && matched.components.default.name
        };
      getUserState().then(loginType=>{
          this.$store.commit('setUserType',loginType);
      })
      let AkipWay = this.$store.state.AkipWay,
          linksArr = this.linksArr;
      let len = linksArr.length;
      if(linksArr.length == 0){
        linksArr.push(info);
      }else if(linksArr[len-1].path == from.path && linksArr[len-2] && linksArr[len-2].path == to.path){
        linksArr.splice(len-1, 1);
        if(AkipWay == ''){
            AkipWay = 'back';
        }
      }else if(linksArr[len-1].path == from.path){
        if(AkipWay == 'replace'){
          linksArr.splice(len-1, 1);
        }
        linksArr.push(info);
        if(AkipWay == ''){
          AkipWay = 'go';
        }
      }
      sessionStorage.setItem('links',JSON.stringify(linksArr));
      if(AkipWay != ''){
        this.transitionName = AkipWay == 'back' ? 'fold-right' : 'fold-left';
        this.$nextTick(()=>{
          this.transitionName = '';
          this.$store.commit('setAkipWay','');
        });
      }
    }
  },
  computed:{
    includedComponents(){
      return this.linksArr.filter(item=>item.meta?.keepAlive).map(item=>item.componentName);
    }
  },
  methods:{
    // 右滑
    // swipeRight(){
    //     // 页面跳转或其它操作
    //     this.$navigation.back();
    // }
  }
}
</script>
<style lang="scss">
.fold-left-enter-active,
.fold-left-leave-active,
.fold-right-enter-active,
.fold-right-leave-active{
    animation-duration: 0.25s;
    animation-timing-function: linear;
    position: fixed !important;
    top: 0;
    left: 0;
}
.fold-left-enter-active {
    animation-name: fold-left-in;
    z-index: 2;
  }
  .fold-left-leave-active {
    animation-name: fold-left-out;
    animation-duration: 0.2s;
    z-index: 1;
  }
.fold-right-enter-active {
    animation-name: fold-right-in;
    z-index: 1;
  }
  .fold-right-leave-active {
    animation-name: fold-right-out;
    z-index: 2;
  }
  $w:750px;
  $w2:$w/5*2;
  @keyframes fold-left-in {//进入
    0% {
      transform: translateX($w);
    }
    90% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(0);
    }
  }
  @keyframes fold-left-out {//出去
    0% {
      transform: translateX(0);
    }
    30% {
      transform: translateX(0);
    }
    100% {
      transform: translateX((-$w2));
    }
  }
  @keyframes fold-right-in {//进入
    0% {
      transform: translateX((-$w2));
    }
    70% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(0);
    }
  }
  @keyframes fold-right-out {//出去
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX($w);
    }
  }
</style>
